import React, { useState } from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import logo from "../../assets/images/vcare/vcare_logo.jpg";

function Header() {
    return (
        <div>
            <div class="navbar">
                <div class="navbar-start"></div>
                <div class="navbar-center">
                    <Link to={paths.home} className=""><img src={logo} width={80} height={70} /></Link>
                </div>
                <div class="navbar-end"></div>
            </div>
            <div class="navbar">
                <div class="navbar-start"></div>
                <div class="navbar-center">
                    <ul class="menu menu-horizontal p-0">
                        <li><Link to={paths.home}>Home</Link></li>
                        <li><a href="https://vcaremm.com/">Shop</a></li>
                        <li><Link to={paths.about}>About Us</Link></li>
                        <li><Link to={paths.contact}>Contact</Link></li>
                    </ul>
                </div>
                <div class="navbar-end"></div>
            </div>
        </div>
    );
}

export default Header;